import { Tag } from "@rio-cloud/rio-uikit";
import { ITruckerPayPlanProduct } from "../../../../models/truckerPayPlan";
import "./styles.scss";

export interface IFranquiaProps {
  products: ITruckerPayPlanProduct[];
  initialOdometer?: number;
  currentOdometer: number;
  initialHourMeter?: number;
  currentHourmeter: number;
}

const Franquia = ({
  products,
  currentOdometer,
  initialOdometer,
  currentHourmeter,
  initialHourMeter,
}: IFranquiaProps) => (
  <section>
    <div className="contract-details-cards">
      {products.length === 0 ? (
        <p className="contract-details-empty">Nenhum item de manutenção informado.</p>
      ) : (
        products.map((item, index) => {
          const totalUsed = (item.coverageTotalUsed ?? 0) + (item.coverageReserved ?? 0);

          // Calculate next odometer/hourmeter values
          // Add 1 to totalUsed to show the next threshold, since totalUsed represents how many times the coverage has been used so far
          // Formula: nextValue = initialValue + (totalUsed + 1) * interval, where interval is either kilometers or hours
          const nextOdometer = initialOdometer && item.kilometers ? initialOdometer + (totalUsed + 1) * item.kilometers : null;
          const nextHourMeter = initialHourMeter && item.hours ? initialHourMeter + (totalUsed + 1) * item.hours : null;

          // Determine if the item is overdue and available to use based on current odometer/hourmeter values compared to the next thresholds
          const isOverdue = (nextOdometer !== null && currentOdometer > nextOdometer) || (nextHourMeter !== null && currentHourmeter > nextHourMeter);
          const isAvailableToUse = (nextOdometer !== null && currentOdometer === nextOdometer) || (nextHourMeter !== null && currentHourmeter === nextHourMeter);

          return (
            <div key={item.ref ?? `item-${index}`} className="contract-details-card">
              <div className="contract-details-card__body">
                <div>
                  <h3 className="contract-details-card__title">
                    {item.description}
                  </h3>
                  <div className="contract-details-card__label">
                    Quantidade de trocas realizadas:{" "}
                    <span className="contract-details-card__ratio">{totalUsed}/{item.coverageQuantity}</span>
                  </div>
                </div>

                <div className="display-flex">
                  <div className="padding-right-10 padding-top-10 min-width-150">
                    {
                      isOverdue === true ? 
                        <Tag icon='rioglyph rioglyph-time-alt' size="small" className="overdue-tag">Troca atrasada</Tag> :
                        isAvailableToUse === true ? <Tag icon='rioglyph rioglyph-ok' size="small" className="available-tag">Troca disponível</Tag> : 
                          <Tag icon='rioglyph rioglyph-time-alt' size="small">Troca planejada</Tag>
                    }
                  </div>
                  <div className="min-width-150">
                    <div>
                      <span className="contract-details-card__field-label">Disponível em:</span>
                    </div>
                    
                    {nextOdometer ? <div>
                      <span className="contract-details-card__field-value">{nextOdometer.toLocaleString("pt-BR")} km</span>
                    </div> : null}

                    {nextHourMeter ? <div>
                      <span className="contract-details-card__field-value">{nextHourMeter.toLocaleString("pt-BR")} h</span>
                    </div> : null}
                  </div>
                </div>

                <div>
                  <div>
                    <span className="contract-details-card__field-label">Intervalo de troca a cada:</span>
                  </div>
                  <div>
                    {nextOdometer !== null ? <>
                      <span className="contract-details-card__field-value">{item.kilometers?.toLocaleString("pt-BR")} km</span>
                    </> : null}
                    {nextHourMeter !== null ? <>
                      <span className="contract-details-card__field-value">{item.hours?.toLocaleString("pt-BR")} h</span>
                    </> : null}

                  </div>
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  </section>
);

export default Franquia;
